import Icon from './Icon';

// "Ngày tập" / "Ngày nghỉ": set automatically from the day's activities, never a toggle.
export default function DayTypeChip({ workoutDay, className = '' }) {
  return workoutDay ? (
    <span className={`inline-flex h-8 items-center gap-1.5 rounded-full bg-train-bg px-3 text-sm font-semibold text-train ${className}`}>
      <Icon name="fire" className="size-4" /> Ngày tập
    </span>
  ) : (
    <span className={`inline-flex h-8 items-center gap-1.5 rounded-full bg-rest-bg px-3 text-sm font-semibold text-rest ${className}`}>
      <Icon name="moon" className="size-4" /> Ngày nghỉ
    </span>
  );
}
